import React, { useState } from 'react';
import SEO from '../../components/SEO/SEO';

import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = ({ setIsAuthenticated }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Default credentials (In production, this should be handled server-side)
    const ADMIN_USERNAME = 'admin';
    const ADMIN_PASSWORD = 'DigiNetwork@2025!';

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
            // Set authentication in localStorage
            localStorage.setItem('adminAuthenticated', 'true');
            localStorage.setItem('adminLoginTime', Date.now().toString());
            setIsAuthenticated(true);
            navigate('/admin/dashboard');
        } else {
            setError('Invalid username or password');
        }
    };

    return (
        <div className="login-page">
            <SEO 
                title="Login Services | Digi Network" 
                description="Learn more about our Login services to grow your business online with Digi Network." 
                canonical="/admin/login" 
            />

            <div className="login-container">
                <div className="login-header">
                    <h1>Digi Network Admin</h1>
                    <p>Blog Management System</p>
                </div>
                <form onSubmit={handleSubmit} className="login-form">
                    {error && <div className="error-message">{error}</div>}
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter username"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary login-btn">
                        Login to Dashboard
                    </button>
                </form>
                <div className="login-footer">
                    <p>Protected Area - Authorized Access Only</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
